<template>
  <div
    v-show="!tauxChanged"
    style="
      position: absolute;
      z-index: 2;
      background-color: #f1f1f1e8;
      bottom: -3px;
      right: -3px;
      left: -128px;
      top: -3px;
      padding-top: 99px;
      font-size: 1.4em;
      padding-left: 303px;
      font-weight: bold;
      transition: 1s;
    "
  >
    Merci de saisir les taux
  </div>
  <div style="display: flex; justify-content: space-between">
    <!-- <div class="a_taux g_frame">
      Taux Gestion :
      <a-input></a-input>
    </div> -->
    <div style="z-index: 11" class="a_taux g_frame">
      Taux Conseil <strong>%</strong>

      <a-input-number
        style="width: 240px"
        @change="tauxConseilChange"
        v-model:value="params.taux_conseil"
        :min="0.1"
        :max="10.0"
        :step="0.1"
      ></a-input-number>
    </div>
    <div style="z-index: 11" class="a_taux g_frame">
      Taux Assureur <strong>%</strong> <span style="font-size: 8px">(Y compris fond social)</span>
      <a-input-number
        style="width: 240px"
        @change="tauxAssureurChange"
        v-model:value="params.taux_assureur"
        :min="0.1"
        :max="10.0"
        :step="0.1"
      ></a-input-number>
    </div>
    <div
      class="g_frame"
      style="width: 460px; text-align: center; line-height: 60px"
    >
      S/P :
      <strong style="color: darkgreen; font-size: 2em">
        {{ json_data_table_total.rapport_sp }}
      </strong>
    </div>
  </div>
  <a-divider></a-divider>

  <!-- <div v-if="false" style="display: flex; justify-content: space-between">
    <div class="g_frame an_stat">
      <h2>S/P <strong>Par Contrats</strong></h2>

      <div style="height: 320px; border-top: 1px solid #f1f1f1">
        <SpColumn
          v-if="params.click === 'contracts'"
          :graph_data="json_data_table"
          :params="params"
          :timestamp="timestamp"
          :key="timestamp"
        />
      </div>

      <a-button
        @click="changeClick('contracts')"
        type="primary"
        :ghost="params.click != 'contracts'"
        shape="round"
        size="large"
      >
        Par contrat
      </a-button>
    </div>
    <div class="g_frame an_stat">
      <h2>S/P <strong>Par Catégories</strong></h2>
      <div style="height: 320px; border-top: 1px solid #f1f1f1">
        <SpColumn
          v-if="params.click === 'categories'"
          :graph_data="json_data_table"
          :params="params"
          :timestamp="timestamp"
          :key="timestamp"
        />
      </div>
      <a-button
        @click="changeClick('categories')"
        type="primary"
        :ghost="params.click != 'categories'"
        shape="round"
        size="large"
      >
        Par catégorie
      </a-button>
    </div>
    <div class="g_frame an_stat">
      <h2>S/P <strong>Par Collèges</strong></h2>
      <div style="height: 320px; border-top: 1px solid #f1f1f1">
        <SpColumn
          v-if="params.click === 'colleges'"
          :graph_data="json_data_table"
          :params="params"
          :timestamp="timestamp"
          :key="timestamp"
        />
      </div>
      <a-button
        @click="changeClick('colleges')"
        type="primary"
        :ghost="params.click != 'colleges'"
        shape="round"
        size="large"
      >
        Par collège
      </a-button>
    </div>
  </div> -->


  <div style="display: flex; justify-content: space-between">
    <div class="g_frame an_stat">
      <h2>S/P <strong>Par Contrats</strong></h2>

      <div style="height: 320px; border-top: 1px solid #f1f1f1">
        <SpColumn
          :graph_data="json_data_all_tables.contracts"
          :params="params"
          :reload="reload"
          :timestamp="timestamp"
        />
      </div>

      <a-button
        @click="changeClick('contracts')"
        type="primary"
        :ghost="params.click != 'contracts'"
        shape="round"
        size="large"
      >
        Par contrat
      </a-button>
    </div>
    <div class="g_frame an_stat">
      <h2>S/P <strong>Par Catégories</strong></h2>
      <div style="height: 320px; border-top: 1px solid #f1f1f1">
        <SpColumn
          :graph_data="json_data_all_tables.categories"
          :params="params"
          :reload="reload"
          :timestamp="timestamp"
        />
      </div>
      <a-button
        @click="changeClick('categories')"
        type="primary"
        :ghost="params.click != 'categories'"
        shape="round"
        size="large"
      >
        Par catégorie
      </a-button>
    </div>
    <div class="g_frame an_stat">
      <h2>S/P <strong>Par Collèges</strong></h2>
      <div style="height: 320px; border-top: 1px solid #f1f1f1">
        <SpColumn
          :graph_data="json_data_all_tables.colleges"
          :params="params"
          :reload="reload"
          :timestamp="timestamp"
        />
      </div>
      <a-button
        @click="changeClick('colleges')"
        type="primary"
        :ghost="params.click != 'colleges'"
        shape="round"
        size="large"
      >
        Par collège
      </a-button>
    </div>
  </div>
  <a-divider></a-divider>

  <ResultTable
    :timestamp="timestamp"
    :action="action"
    :json_data_table="json_data_table"
    :tt="json_data_table_total"
  />

  <FrameTable
    :timestamp="timestamp"
    :action="action"
    :json_data_frame="json_data_frame"
  />
</template>

<script>
import ResultTable from "./ResultTable.vue";
import FrameTable from "./FrameTable.vue";
import SpColumn from "./SpColumn.vue";

export default {
  components: { ResultTable, SpColumn, FrameTable },
  props: {
    timestamp: {
      type: Number,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    json_data_advanced: {
      type: Object,
      required: true,
    },
    json_data_table: {
      type: Object,
      required: true,
    },
    json_data_all_tables: {
      type: Object,
      required: true,
    },
    json_data_table_total: {
      type: Object,
      required: true,
    },
    json_data_frame: {
      type: Object,
      required: true,
    },
  },
  emits: ["get-client-stat"],
  watch: {
    timestamp() {
      this.reload = true

      if(this.button_click){
        this.reload = false
      }

      setTimeout(() => {
        this.button_click = false
      }, 300);

    },
  },
  data() {
    return {
      timeout: 0,
      tauxChanged: false,
      reload: true,
      button_click: false
    };
  },
  methods: {
    tauxConseilChange(e) {
      this.tauxChanged = true;
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$emit("get-client-stat");
      }, 500);
    },
    tauxAssureurChange(e) {
      this.tauxChanged = true;
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$emit("get-client-stat");
      }, 500);
    },
    changeClick(click) {
      this.button_click = true;
      this.params.click = click;
      this.$emit("get-client-stat");
    },
  },
};
</script>

<style scoped>
.a_taux {
  width: 280px;
  height: 80px;
  font-size: 1.2em;
}
.an_stat {
  width: 352px;
  height: 428px;
  text-align: center;
}
</style>